const mentionsI18n = {
  "fr": {
    "hero": {
      "title": "Mentions légales",
      "desc": "Informations légales concernant l’éditeur du site 123back et son hébergeur."
    },
    "editor": {
      "title": "Éditeur du site",
      "corporateNameLabel": "Raison sociale :",
      "corporateName": "S&T France",
      "legalFormLabel": "Forme juridique :",
      "legalForm": "",
      "addressLabel": "Adresse du siège social :",
      "address": "",
      "siretLabel": "SIRET :",
      "siret": "93343846700014",
      "emailLabel": "E-mail :",
      "email": "contact@123back.eu"
    },
    "publication": {
      "title": "Responsable de la publication",
      "text": ""
    },
    "hosting": {
      "title": "Hébergeur du site",
      "nameLabel": "Nom :",
      "name": "Hostinger International Ltd",
      "addressLabel": "Adresse :",
      "address": "61 Lordou Vironos Street, 6023 Larnaca, Chypre",
      "websiteLabel": "Site web :",
      "website": "https://www.hostinger.com"
    },
    "ip": {
      "title": "Propriété intellectuelle",
      "text": "L’ensemble des éléments présents sur le site 123back (textes, logos, graphismes, vidéos, icônes, mise en page, etc.) est protégé par le droit d’auteur et, plus largement, par le droit de la propriété intellectuelle. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de S&T France."
    },
    "data": {
      "title": "Données personnelles",
      "text": "Les informations collectées via le site 123back sont traitées par S&T France afin de répondre aux demandes des utilisateurs et d’assurer la gestion du service de rachat. Pour plus d’informations sur le traitement de vos données et l’exercice de vos droits (accès, rectification, suppression, opposition, etc.), vous pouvez contacter S&T France à l’adresse : contact@123back.eu. Une politique de confidentialité dédiée pourra détailler ces traitements."
    }
  },
  "en": {
    "hero": {
      "title": "Legal notice",
      "desc": "Legal information about the 123back website and its hosting provider."
    },
    "editor": {
      "title": "Website publisher",
      "corporateNameLabel": "Company name:",
      "corporateName": "S&T France",
      "legalFormLabel": "Legal form:",
      "legalForm": "",
      "addressLabel": "Registered office address:",
      "address": "",
      "siretLabel": "SIRET (France):",
      "siret": "93343846700014",
      "emailLabel": "Email:",
      "email": "contact@123back.eu"
    },
    "publication": {
      "title": "Publishing director",
      "text": ""
    },
    "hosting": {
      "title": "Provider di hosting",
      "nameLabel": "Name:",
      "name": "Hostinger International Ltd",
      "addressLabel": "Address:",
      "address": "61 Lordou Vironos Street, 6023 Larnaca, Cyprus",
      "websiteLabel": "Webseite:",
      "website": "https://www.hostinger.com"
    },
    "ip": {
      "title": "Intellectual property",
      "text": "All elements on the 123back website (texts, logos, graphics, videos, icons, layout, etc.) are protected by copyright and, more generally, by intellectual property law. Any reproduction, representation, modification, publication, or adaptation of all or part of the site, by any means, is prohibited without the prior written consent of S&T France."
    },
    "data": {
      "title": "Personal data",
      "text": "Information collected via the 123back website is processed by S&T France in order to answer user requests and manage the buyback service. For more details about how your data is processed and how to exercise your rights (access, rectification, deletion, objection, etc.), you can contact S&T France at: contact@123back.eu. A dedicated privacy policy may provide further details."
    }
  },
  "pl": {
    "hero": {
      "title": "Informacje prawne",
      "desc": "Informacje prawne dotyczące serwisu 123back oraz jego dostawcy hostingu."
    },
    "editor": {
      "title": "Wydawca serwisu",
      "corporateNameLabel": "Nazwa spółki:",
      "corporateName": "S&T France",
      "legalFormLabel": "Forma prawna:",
      "legalForm": "",
      "addressLabel": "Adres siedziby:",
      "address": "",
      "siretLabel": "SIRET (Francja):",
      "siret": "93343846700014",
      "emailLabel": "E-mail:",
      "email": "contact@123back.eu"
    },
    "publication": {
      "title": "Odpowiedzialny za publikację",
      "text": ""
    },
    "hosting": {
      "title": "Dostawca hostingu",
      "nameLabel": "Nazwa:",
      "name": "Hostinger International Ltd",
      "addressLabel": "Adres:",
      "address": "61 Lordou Vironos Street, 6023 Larnaca, Cypr",
      "websiteLabel": "Strona internetowa:",
      "website": "https://www.hostinger.com"
    },
    "ip": {
      "title": "Własność intelektualna",
      "text": "Wszystkie elementy obecne w serwisie 123back (teksty, logotypy, grafiki, filmy, ikony, układ strony itd.) są chronione prawem autorskim oraz innymi przepisami z zakresu własności intelektualnej. Jakiekolwiek kopiowanie, rozpowszechnianie, modyfikowanie lub publikowanie całości lub części serwisu bez pisemnej zgody S&T France jest zabronione."
    },
    "data": {
      "title": "Dane osobowe",
      "text": "Informacje zbierane za pośrednictwem serwisu 123back są przetwarzane przez S&T France w celu obsługi zapytań użytkowników oraz zarządzania usługą odkupu. Aby uzyskać więcej informacji na temat przetwarzania danych oraz sposobów realizacji swoich praw (dostęp, sprostowanie, usunięcie, sprzeciw itd.), możesz skontaktować się ze S&T France pod adresem: contact@123back.eu. Szczegółowe informacje mogą zostać przedstawione w dedykowanej polityce prywatności."
    }
  },
  "es": {
    "hero": {
      "title": "Aviso legal",
      "desc": "Información legal sobre el sitio web 123back y su proveedor de alojamiento."
    },
    "editor": {
      "title": "Editor del sitio web",
      "corporateNameLabel": "Razón social:",
      "corporateName": "S&T France",
      "legalFormLabel": "Forma jurídica:",
      "legalForm": "",
      "addressLabel": "Dirección de la sede social:",
      "address": "",
      "siretLabel": "SIRET (Francia):",
      "siret": "93343846700014",
      "emailLabel": "Correo electrónico:",
      "email": "contact@123back.eu"
    },
    "publication": {
      "title": "Responsable de la publicación",
      "text": ""
    },
    "hosting": {
      "title": "Proveedor de alojamiento",
      "nameLabel": "Nombre:",
      "name": "Hostinger International Ltd",
      "addressLabel": "Dirección:",
      "address": "61 Lordou Vironos Street, 6023 Larnaca, Chipre",
      "websiteLabel": "Sitio web:",
      "website": "https://www.hostinger.com"
    },
    "ip": {
      "title": "Propiedad intelectual",
      "text": "Todos los elementos presentes en el sitio 123back (textos, logotipos, gráficos, vídeos, iconos, maquetación, etc.) están protegidos por derechos de autor y, en general, por la normativa de propiedad intelectual. Queda prohibida cualquier reproducción, representación, modificación, publicación o adaptación total o parcial del sitio sin la autorización previa por escrito de S&T France."
    },
    "data": {
      "title": "Datos personales",
      "text": "La información recopilada a través del sitio 123back es tratada por S&T France con el fin de responder a las solicitudes de los usuarios y gestionar el servicio de recompra. Para más información sobre el tratamiento de tus datos y el ejercicio de tus derechos (acceso, rectificación, supresión, oposición, etc.), puedes contactar con S&T France en: contact@123back.eu. Una política de privacidad específica podrá detallar estos tratamientos."
    }
  },
  "it": {
    "hero": {
      "title": "Avviso legale",
      "desc": "Informazioni legali sul sito 123back e sul suo provider di hosting."
    },
    "editor": {
      "title": "Sito web editore",
      "corporateNameLabel": "Nome della Società:",
      "corporateName": "S&T Francia",
      "legalFormLabel": "Modulo legale:",
      "legalForm": "",
      "addressLabel": "Sede legale:",
      "address": "",
      "siretLabel": "SIRET (Francia):",
      "siret": "93343846700014",
      "emailLabel": "Email:",
      "email": "contact@123back.eu"
    },
    "publication": {
      "title": "Direttore editoriale",
      "text": ""
    },
    "hosting": {
      "title": "Hosting provider",
      "nameLabel": "Nome:",
      "name": "Hostinger International Ltd",
      "addressLabel": "Indirizzo:",
      "address": "61 Lordou Vironos Street, 6023 Larnaca, Cipro",
      "websiteLabel": "Sito web:",
      "website": "https://www.hostinger.com"
    },
    "ip": {
      "title": "Proprietà intellettuale",
      "text": "Tutti gli elementi del sito 123back (tessi, loghi, grafica, video, icone, layout, ecc.) sono protetti dal diritto d'autore e, più in generale, dalla legge sulla proprietà intellettuale. Qualsiasi riproduzione, rappresentazione, modifica, pubblicazione o adattamento di tutto o parte del sito, in qualsiasi modo, è vietata senza il preventivo consenso scritto di S&T France."
    },
    "data": {
      "title": "Dati personali",
      "text": "Le informazioni raccolte tramite il sito 123back vengono elaborate da S&T France per rispondere alle richieste degli utenti e gestire il servizio di buyback. Per ulteriori informazioni su come vengono elaborati i tuoi dati e su come esercitare i tuoi diritti (accesso, rettifica, cancellazione, opposizione, ecc.), puoi contattare S&T France a: contact@123back.eu. Una politica sulla privacy dedicata può fornire ulteriori dettagli."
    }
  },
  "de": {
    "hero": {
      "title": "Rechtliche Hinweise",
      "desc": "Rechtliche Informationen über die 123back Website und ihren Hosting-Provider."
    },
    "editor": {
      "title": "Herausgeber der Website",
      "corporateNameLabel": "Name des Unternehmens:",
      "corporateName": "S&T Frankreich",
      "legalFormLabel": "Rechtsform:",
      "legalForm": "",
      "addressLabel": "Eingetragene Anschrift:",
      "address": "",
      "siretLabel": "SIRET (Frankreich):",
      "siret": "93343846700014",
      "emailLabel": "E-Mail:",
      "email": "contact@123back.eu"
    },
    "publication": {
      "title": "Verlagsdirektor",
      "text": ""
    },
    "hosting": {
      "title": "Hosting-Anbieter",
      "nameLabel": "Name:",
      "name": "Hostinger International Ltd",
      "addressLabel": "Anschrift:",
      "address": "61 Lordou Vironos Street, 6023 Larnaca, Zypern",
      "websiteLabel": "Website:",
      "website": "https://www.hostinger.com"
    },
    "ip": {
      "title": "Geistiges Eigentum",
      "text": "Alle Elemente der 123back-Website (Texte, Logos, Grafiken, Videos, Icons, Layout usw.) sind urheberrechtlich und allgemein durch das Recht auf geistiges Eigentum geschützt. Jegliche Reproduktion, Darstellung, Änderung, Veröffentlichung oder Anpassung aller oder eines Teils der Website ist ohne vorherige schriftliche Zustimmung von S & T France verboten."
    },
    "data": {
      "title": "Personenbezogene Daten",
      "text": "Die über die 123back-Website gesammelten Informationen werden von S&T France verarbeitet, um Benutzeranfragen zu beantworten und den Rückkaufservice zu verwalten. Für weitere Details darüber, wie Ihre Daten verarbeitet werden und wie Sie Ihre Rechte ausüben können (Zugriff, Berichtigung, Löschung, Widerspruch usw.), können Sie sich an S&T France wenden: contact@123back.eu. Eine dedizierte Datenschutzerklärung kann weitere Details enthalten."
    }
  },
  "pt": {
    "hero": {
      "title": "Aviso jurídico",
      "desc": "Informações legais sobre o site 123back e seu provedor de hospedagem."
    },
    "editor": {
      "title": "Editor de páginas Web",
      "corporateNameLabel": "Nome da empresa:",
      "corporateName": "S&T França",
      "legalFormLabel": "Forma jurídica:",
      "legalForm": "",
      "addressLabel": "Endereço registado:",
      "address": "",
      "siretLabel": "SIRET (França):",
      "siret": "93343846700014",
      "emailLabel": "E- mail:",
      "email": "contact@123back.eu"
    },
    "publication": {
      "title": "Director editorial",
      "text": ""
    },
    "hosting": {
      "title": "Prestador de alojamento",
      "nameLabel": "Nome:",
      "name": "Hostinger International Ltd.",
      "addressLabel": "Endereço:",
      "address": "61 Lordou Vironos Street, 6023 Larnaca, Chipre",
      "websiteLabel": "Webseite:",
      "website": "https://www.hostinger.com"
    },
    "ip": {
      "title": "Propriedade intelectual",
      "text": "Todos os elementos do site 123back (textos, logotipos, gráficos, vídeos, ícones, layout, etc.) são protegidos por direitos autorais e, mais geralmente, pela lei de propriedade intelectual. Qualquer reprodução, representação, modificação, publicação ou adaptação de toda ou parte do site, por qualquer meio, é proibida sem o consentimento prévio por escrito da S&T França."
    },
    "data": {
      "title": "Dados pessoais",
      "text": "As informações recolhidas através do site 123back são processadas pela S&T France para responder às solicitações dos utilizadores e gerir o serviço de recompra. Para mais detalhes sobre como seus dados são processados e como exercer seus direitos (acesso, retificação, exclusão, objeção, etc.), você pode contatar S&T France em: contact@123back.eu. Uma política de privacidade dedicada pode fornecer mais detalhes."
    }
  },
  "cs": {
    "hero": {
      "title": "Právní upozornění",
      "desc": "Právní informace o webových stránkách123backa jeho poskytovateli hostingu."
    },
    "editor": {
      "title": "Vydavatel webových stránek",
      "corporateNameLabel": "Název společnosti:",
      "corporateName": "S & T Francie",
      "legalFormLabel": "Právní forma:",
      "legalForm": "",
      "addressLabel": "Adresa sídla:",
      "address": "",
      "siretLabel": "SIRET (Francie):",
      "siret": "93343846700014",
      "emailLabel": "E-mail:",
      "email": "contact @123back.eu"
    },
    "publication": {
      "title": "Vydavatel",
      "text": ""
    },
    "hosting": {
      "title": "Poskytovatel di hosting",
      "nameLabel": "Název:",
      "name": "Hostinger International Ltd.",
      "addressLabel": "Adresa:",
      "address": "61 Lordou Vironos Street, 6023 Larnaca, Kypr",
      "websiteLabel": "Webseite:",
      "website": "https://www.hostinger.com"
    },
    "ip": {
      "title": "Duševní vlastnictví",
      "text": "Všechny prvky na webových stránkách123back(texty, loga, grafika, videa, ikony, rozložení atd.) jsou chráněny autorským právem a obecněji právem duševního vlastnictví. Bez předchozího písemného souhlasu S & T France je zakázána jakákoli reprodukce, reprezentace, změna, zveřejnění nebo úprava celé lokality nebo její části."
    },
    "data": {
      "title": "Osobní údaje",
      "text": "Informace shromážděné na webových stránkách123backzpracovává S & T Francie s cílem odpovědět na uživatelské požadavky a spravovat službu zpětného odkupu. Podrobnější informace o tom, jak jsou Vaše údaje zpracovávány a jak vykonávat svá práva (přístup, oprava, výmaz, námitka atd.), můžete kontaktovat S & T Francii na adrese: contact @123back.eu. Další podrobnosti mohou poskytnout zvláštní zásady ochrany soukromí."
    }
  },
  "nl": {
    "hero": {
      "title": "Mededeling",
      "desc": "Juridische informatie over de123backwebsite en haar hosting provider."
    },
    "editor": {
      "title": "Website uitgever",
      "corporateNameLabel": "Bedrijfsnaam:",
      "corporateName": "S&T Frankrijk",
      "legalFormLabel": "Rechtsvorm:",
      "legalForm": "",
      "addressLabel": "Geregistreerd kantooradres:",
      "address": "",
      "siretLabel": "SIRET (Frankrijk):",
      "siret": "93343846700014",
      "emailLabel": "E-mail:",
      "email": "contact@123back.eu"
    },
    "publication": {
      "title": "Directeur uitgeverij",
      "text": ""
    },
    "hosting": {
      "title": "Provider di hosting",
      "nameLabel": "Naam:",
      "name": "Hostinger International Ltd",
      "addressLabel": "Adres:",
      "address": "61 Lordou Vironos Street, 6023 Larnaca, Cyprus",
      "websiteLabel": "Webseite:",
      "website": "https://www.hostinger.com"
    },
    "ip": {
      "title": "Intellectuele eigendom",
      "text": "Alle elementen op de123backwebsite (teksten, logo's, graphics, video's, pictogrammen, lay-out, enz.) zijn beschermd door het auteursrecht en, meer in het algemeen, door het intellectuele eigendomsrecht. Elke reproductie, weergave, wijziging, publicatie of aanpassing van het gehele gebied of een deel daarvan is op enigerlei wijze verboden zonder voorafgaande schriftelijke toestemming van S&T France."
    },
    "data": {
      "title": "Persoonsgegevens",
      "text": "Informatie verzameld via de123backwebsite wordt verwerkt door S&T France om gebruikersverzoeken te beantwoorden en de inkoopdienst te beheren. Voor meer informatie over hoe uw gegevens worden verwerkt en hoe u uw rechten kunt uitoefenen (toegang, rectificatie, verwijdering, bezwaar, enz.), kunt u contact opnemen met S&T France via: contact@123back.eu. Een specifiek privacybeleid kan verdere details bevatten."
    }
  }
};

export default mentionsI18n;
